<template>
  <div class="chart" ref="G2ChartRef"></div>
</template>

<script>
  export default {
    name: 'EhfChart',
  }
</script>

<script setup>
  import { isNull } from '@/utils'
  import { Chart } from '@antv/g2'
  import { onMounted, ref, toRefs, watch } from 'vue'

  const props = defineProps({
    // 配置项
    config: {
      type: Object,
      default() {
        return {}
      },
    },
    // y轴数组
    options: {
      type: Array,
      default() {
        return []
      },
    },
    // 数据
    data: {
      type: Array,
      default() {
        return []
      },
    },
  })
  const { config, options, data } = toRefs(props)

  watch(
    [options, data],
    () => {
      // y轴数组/数据变化时重新生成图表
      generateChart()
    },
    { deep: true }
  )

  let G2Chart = null // g2图表实例
  const G2ChartRef = ref(null) // g2图表Ref
  const chartBlockHeight = ref(0) // 图表块高度
  const colors = ['#38c060', '#f1657d', '#156820', '#9ebeec', '#23558c', '#715890'] // 图表柱/线的颜色

  onMounted(() => {
    adjustChartHeight()
    generateChart()
  })

  // 获取图表配置
  const getChartConfig = () => {
    return {
      container: G2ChartRef.value,
      autoFit: true,
      height: chartBlockHeight.value,
      padding: config.value.padding || [30, 50, 80, 30],
    }
  }
  // 生成图表内容
  const generateChart = () => {
    const chartConfig = getChartConfig()
    if (isNull(G2Chart)) {
      G2Chart = new Chart(chartConfig)
    } else {
      G2Chart.clear()
    }
    var defs = {}
    options.value.forEach((item) => {
      const itemConfig = config.value[item.name] || config.value
      if (['interval', 'line'].indexOf(item.shape) === -1) {
        console.error('图表类型有误')
        return
      }
      defs[item.valueName] = {
        min: 0,
        formatter: function (v) {
          if (v !== undefined) {
            return v + item.unit
          }
        },
      }
      G2Chart.axis(item.valueName, {
        label: {
          offset: itemConfig.axisOffset || 0,
        },
        position: itemConfig.axisPosition || 'left',
      })
      G2Chart.legend(item.name, {
        allowAllCanceled: true,
      })
      if (item.shape === 'interval') {
        // 柱状
        G2Chart.interval()
          .encode('x', config.value.xkey)
          .encode('y', item.valueName)
          .encode('color', item.name)
          .scale('color', itemConfig.colors || colors)
      } else {
        // 折线
        G2Chart.line()
          .encode('x', config.value.xkey)
          .encode('y', item.valueName)
          .encode('color', item.name)
          .scale('color', itemConfig.colors || colors)
          .shape('smooth')
        G2Chart.point()
          .encode('x', config.value.xkey)
          .encode('y', item.valueName)
          .encode('color', item.name)
          .scale('color', itemConfig.colors || colors)
          .size(4)
          .shape('circle')
          .style({
            stroke: '#fff',
            lineWidth: 1,
          })
        G2Chart.interaction('tooltip', {
          crosshairs: {
            type: 'y',
          },
        })
      }
    })
    G2Chart.data(data.value)
    G2Chart.scale(defs)
    G2Chart.render()
  }
  // 调整图表区域高度
  const adjustChartHeight = () => {
    chartBlockHeight.value = G2ChartRef.value.clientHeight
  }
</script>

<style lang="scss" scoped>
  .chart {
    width: 100%;
    height: 100%;
  }
</style>
